// Direktiva na renderovanie Mojich tiketov
directives.playerTicketsDirective.myTickets = function() {
    var directive = {
        ".my-ticket": {
            "ticket<-tickets": {
                ".@id": function () {
                    if (this.Status) {
                        this.OverallStatus = "";
                        // Zistenie stavu pre dany tiket
                        if (this.IsNoRiskTicket) {
                            this.OverallStatus = "No-risc";
                        } else if (this.Status === "closed") {
                            // Uzavrety tiket
                            if (this.WinningStatus === "nonwinning") {
                                // Nevyherny tiket
                                this.OverallStatus = "Lost";

                            } else if (this.WinningStatus === "winning") {
                                this.OverallStatus = "Won";
                                // Vyherny tiket, predany tiket (IsBuyBackTicket = 1) alebo exspirovany tiket
                                if (this.IsPayable && this.Status === "closed") {
                                    // Uzavrety, vyplatitelny tiket
                                    var secondsToShowExpiration = profile.NoticeBeforeExpiration * 24 * 60 * 60;
                                    secondsTicketNotExpired = (new Date(this.ExpiresAt) - new Date(today)) / 1000;

                                     if (secondsTicketNotExpired <= secondsToShowExpiration) {
                                        // Vyherny tiket ktory zanedlho exspiruje
                                        this.showNoticeExpiration = true;
                                    } else {
                                        this.showNoticeNonPaid = true;
                                    }
                                }
                            }
                            if (this.IsCompensationTicket) {
                                this.OverallStatus = "Compensation";
                            } else if (this.IsBuyBackTicket) {
                                this.OverallStatus = "Buyback";
                            } else if (this.IsNoRiskTicket) {
                                this.OverallStatus = "No-risc-ico";
                            } else if (this.Status === "Paid") {
                                this.OverallStatus = "Won-ico";
                            }
                        } else if (this.Status === "approved") {
                            // Schvaleny tiket, neuzavrety
                            // Moze sa jednat o SRT a v takom pripade ma "WinningStatus": "nonwinning"
                            // Neznamena ze je nevyherny, ale ze je momentalne nevyherny
                            this.OverallStatus = "Pend";
                        } else if (this.Status === "canceled") {
                            // Stornovany tiket ma "Status": "canceled"
                            this.OverallStatus = "Canceled";
                        } else if (this.Status === "expired" || this.Status === "forfeited") {
                            // Fyzicky exspirovany tiket ma Status: "expired", Virtualne exspirovany ma Status "forfeited"
                            this.OverallStatus = "Expired";
                        } else if (this.Status === "refused") {
                            this.OverallStatus = "Refused";
                        }
                    }
                    return this.SportBoxTicketGUID;
                },
                ".@onclick": function () {
                    if (this.SportBoxTicketGUID) {
                        return 'ticketDetail.barCodeTicketInput("' + this.SportBoxTicketGUID + '", true)';
                    }
                },
                ".rate": function () {
                    if (this.TicketType === ticket.state.ticketWsTypes.SRT && this.BusinessRate) {
                        // Kombinovany tiket
                        return shared.formatNumber(shared.floor2(this.BusinessRate, 2), true);
                    } else if (this.IsBuyBackTicket) {
                        // Jednoduchy odpredany tiket
                        return texts.MyTicketsBuyBack;
                    }
                    return shared.formatNumber(shared.floor2(this.TicketRateOverall, 2), true);
                },
                ".rate@class+": function () {
                    if (this.IsBuyBackTicket) {
                        return " no-background";
                    }
                },
                ".icon-state@class+": function() {
                    if (this.OverallStatus) {
                        return " " + this.OverallStatus + "-ico";
                    }
                },
                ".not-paid": function() {
                    if (this.showNoticeExpiration) {
                        // Zobrazi informaciu o coskorej exspiracii tiketu
                        return texts.MyTicketsExpireSoon;
                    } else if (this.showNoticeNonPaid) {
                        // Zobrazi informaciu o nevyplatenom tikete
                        return texts.MyTicketsNotPaid;
                    }
                },
                ".not-paid@class+": function() {
                    if (this.showNoticeExpiration) {
                        return " highlight";
                    }
                },
                ".bet": function () {
                    if (this.AmountMoneyOverall) {
                        var currency = profile.Currency;
                        if (this.WinCurrencyFunded === 1) {
                            currency += "<div class='icon-win'></div>";
                        }
                        return shared.floor2(this.AmountMoneyOverall, 1) + " " + currency;
                    }
                },
                ".pot-win": function () {
                    if (this.WinningStatus === "winning" && this.AmountMoneyWonWithBonus) {
                        // Pokial sa jedna o vyherny tiket tak zobrazi skutocnu vyhru (pre vyherny tiket plati: FiscalOverallPotWin = OverallPotWin + SuperBankValue + BoosterBonusValue)
                        // AmountMoneyWonWithBonus = Skutocna vyhra vratene BoosterBonusValue, ale bez SuperBankValue
                        return shared.floor2(this.FiscalOverallPotWin, 1) + " " + profile.Currency;
                    } else if (this.AmountMoneyWinWithBonus) {
                        // Zobrazi potencionalnu vyhru
                        return shared.floor2(this.AmountMoneyWinWithBonus, 1) + " " + profile.Currency;
                    }
                },
                ".pot-win@class+": function () {
                    if (this.AmountMoneyWin && this.OverallStatus) {
                        return " " + this.OverallStatus;
                    }
                },
                ".odd-number.Pend": function () {
                    if (this.parsedOddsCount.pend) {
                        return this.parsedOddsCount.pend;
                    }
                },
                ".odd-number.Pend@class+": function () {
                    this.parsedOddsCount = player.playerTickets.parseOddsStatus(this.OddWinStats);
                    if (typeof this.parsedOddsCount.pend === "undefined" || this.Status === "canceled") {
                        this.parsedOddsCount.pend = 0;
                        return " ui-disabled";
                    }
                },
                ".odd-number.Won": function () {
                    if  (this.parsedOddsCount.win) {
                        return this.parsedOddsCount.win;
                    }
                },
                ".odd-number.Won@class+": function () {
                    if  (typeof this.parsedOddsCount.win === "undefined") {
                        return " ui-disabled";
                    }
                },
                ".odd-number.Lost": function () {
                    if  (this.parsedOddsCount.loss) {
                        return this.parsedOddsCount.loss;
                    }
                },
                ".odd-number.Lost@class+": function () {
                    if (typeof this.parsedOddsCount.loss === "undefined") {
                        return " ui-disabled";
                    }
                }
            }
        }
    }
    T.myTickets = $p("#ticket #myTicketsList").compile(directive);
}
